export default class TagEntity {
  constructor() {
    this.key = null;
    this.value = null;
    this.isArchived = null;
    this.path = null;
    this.tagBudget = null;
    this.categoryBudget = null;
  }
  getTagKey() {
    return this.key;
  }
  getTagName() {
    return this.name;
  }
  getCurrentSpendAmount() {
    return this.currentSpendAmount;
  }
  getPreviousSpendAmount() {
    return this.previousSpendAmount;
  }
  getTagType() {
    return this.tagType;
  }
}
